import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { cashpaymentApi } from 'src/app/config/api-url';

@Injectable({
  providedIn: 'root'
})
export class CashpaymentService {

  constructor(private apiService: ApiService) { }

  getVendorLevelStatus(): any {
    return this.apiService.get(cashpaymentApi.getVendorLevelStatus);
  }

  getVendorLevelGridData(reqParam: any): any {
    return this.apiService.get(`${cashpaymentApi.getVendorData}${reqParam}`);
  }

  getPartnerLevelStatusList(): any {
    return this.apiService.get(cashpaymentApi.getPartnerLevelStatus);
  }

  getVendorLevelBreakdownTableData(reqParam: any): any {
    return this.apiService.get(`${cashpaymentApi.getVendorLevelBreakdownData}${reqParam}`);
  }

  getListofCashPaymentByPartner(reqParam: any): any {
    return this.apiService.get(`${cashpaymentApi.getCashpaymentByPartner}${reqParam}`);
  }

  getcashpaymentVendorLevelStatusHistory(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getcashpaymentVendorlevelStatusHistory}${req}`);
  }

  getcashPaymentPartnerLevelStatusHistory(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getcashpaymentPartnerLevelStatusHistory}${req}`);
  }

  getByPartnerBreakdownData(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getByPartnerBreakdownList}${req}`);
  }

  updateStatusOfCashpaymentAtVendorLeavel(req: any): any {
    return this.apiService.postCompleteResponse(cashpaymentApi.updateStatusOfCashpaymentAtVendorLevel, req);
  }

  downloadPaymentFile(req: any): any {
    return this.apiService.get(`${cashpaymentApi.downloadPaymentFile}${req}`);
  }

  uploadVistexPaymentFile(fileData: any): any {
    return this.apiService.postForFileUpload(cashpaymentApi.uploadVistexPaymentFIle, fileData);
  }

  getListOfPartnerConsolidatedData(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getPartnerConsolidatedList}${req}`);
  }

  getPartnerLeaderBreakdownData(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getPartnerLeaderBreakdownData}${req}`);
  }

  getStatusHistoryOfConsolidatedCashpaymentData(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getPartnerLeaderStatusHistory}${req}`);
  }

  getPartnerConsolidatedBreakdownRunData(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getPartnerConsolidatedBreakdownRun}${req}`);
  }

  submitProofOfPayment(req: any): any {
    return this.apiService.post(cashpaymentApi.postSubmitProofOfPayment, req);
  }

  getSellerlevelCashData(req: any): any {
    return this.apiService.get(`${cashpaymentApi.getByuserConsolidatedData}${req}`);
  }

  getSellerStatusList(): any {
    return this.apiService.get(cashpaymentApi.getbyUserStatusList);
  }

  buildPartnerlevelExportUrl(companyId: string): string {
    return `${cashpaymentApi.getPartnerConsolidatedList}companyId=${companyId}&asExcel=true`;
  }

  buildPartnerLevelBreakdownExportUrl(companyId: string, cashPaymentId: string): string {
    return `${cashpaymentApi.getPartnerLeaderBreakdownData}companyId=${companyId}&cashPaymentId=${cashPaymentId}&asExcel=true`;
  }

  buildPartnerLevelDetailedBreakdownUrl(companyId: string, cashPaymentId: string): string {
    return `${cashpaymentApi.getPolevelBreakdownData}companyId=${companyId}&cashPaymentId=${cashPaymentId}&asExcel=true`;
  }

}
